import axios from 'axios';
import packageJson from '../../../package.json';
import { requestInterceptor, responseInterceptor } from './interceptors';

const instance = axios.create({
  headers: {
    'x-app-name': packageJson.name,
    'x-app-version': packageJson.version,
    bot: 'hotmartbwrouter@msging.net',
  },
});

instance.interceptors.request.use(requestInterceptor);
instance.interceptors.response.use(responseInterceptor);

export default instance;
